import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useFormik } from 'formik'
import { find, map } from 'lodash'
import { useEffect } from 'react'
import * as yup from 'yup'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'
import { useWrapperStore } from '../../store/storeWrapper'

const validationSchema = yup.object({
    idMemoPrompt: yup.string().required('Пожалуйста, выберите типо саммари '),
})

export const RecordCreateStateBy = ({ open, handleClose }) => {
    const {
        memoDetail,
        memoPrompt,
        createStateByRecord,
        errorCreateStateByRecord,
        fetchMemoPrompt,
        fetchMemoList,
        setIdActiveMemoDetail,
        memoList,
    } = useAssistantAdministrationStore((state) => state)

    const { modelListActive } = useWrapperStore((state) => state)

    useEffect(() => {
        if (modelListActive) {
            fetchMemoPrompt()
        }
    }, [modelListActive])

    const formik = useFormik({
        initialValues: {
            idMemoPrompt: '',
            extra_context: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const { idMemoPrompt, extra_context } = values
            await createStateByRecord({
                record_id: memoDetail?.record_id,
                record_stage_type: 'MEMO',
                settings: {
                    memo_prompt_id: idMemoPrompt,
                    extra_context,
                },
            })
            if (!errorCreateStateByRecord) {
                await fetchMemoList({ record_id: memoDetail?.record_id })
                await setIdActiveMemoDetail(memoList[0]?.id)
                handleClose()
            }
        },
    })

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        width: '700px',
                    },
                }}
                sx={{}}
                open={open}
                onClose={handleClose}>
                <DialogTitle sx={{ mb: 0 }}>Перегенирировать саммари</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <form onSubmit={formik.handleSubmit}>
                            {memoPrompt && memoPrompt.length === 0 && (
                                <Typography color="error" variant="h4" sx={{ margin: '0px auto ' }}>
                                    {`Перегенерация Саммари не может быть выполнена из-за того, в выбранных моделях отсутствуют виды расшифровок. Сделать их доступными можно в глобальных настройках`}
                                </Typography>
                            )}
                            {memoPrompt && memoPrompt.length > 0 && (
                                <>
                                    <FormControl fullWidth sx={{ mt: 4 }}>
                                        <TextField
                                            multiline
                                            rows={3}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '24px',
                                                },
                                            }}
                                            // margin="dense"
                                            id="extra_context"
                                            name="extra_context"
                                            label="Контекст записи"
                                            fullWidth
                                            value={formik.values.extra_context}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={
                                                formik.touched.extra_context &&
                                                Boolean(formik.errors.extra_context)
                                            }
                                            helperText={
                                                formik.touched.extra_context &&
                                                formik.errors.extra_context
                                            }
                                        />
                                        {memoPrompt.length > 0 && (
                                            <>
                                                <TextField
                                                    sx={{ marginTop: 4 }}
                                                    select
                                                    required
                                                    id="idMemoPrompt"
                                                    name="idMemoPrompt"
                                                    value={formik.values.idMemoPrompt}
                                                    label="Какое саммари сделать?"
                                                    onChange={formik.handleChange}
                                                    error={
                                                        formik.touched.idMemoPrompt &&
                                                        Boolean(formik.errors.idMemoPrompt)
                                                    }
                                                    onBlur={formik.handleBlur}>
                                                    {map(memoPrompt, (item, index) => {
                                                        return (
                                                            <MenuItem value={item.id}>
                                                                {item.title}
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </TextField>
                                                <Typography>
                                                    {
                                                        find(memoPrompt, {
                                                            id: formik.values.idMemoPrompt,
                                                        })?.description
                                                    }
                                                </Typography>
                                            </>
                                        )}
                                    </FormControl>
                                </>
                            )}

                            <Button
                                disabled={
                                    !(formik.isValid && formik.dirty) ||
                                    errorCreateStateByRecord ||
                                    !memoPrompt ||
                                    (memoPrompt && memoPrompt.length === 0)
                                }
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}>
                                Запустить
                            </Button>
                            <Button
                                fullWidth
                                onClick={handleClose}
                                autoFocus
                                variant="outlined"
                                color="primary">
                                Отмена
                            </Button>
                        </form>

                        {errorCreateStateByRecord && <Typography>Ошибка</Typography>}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    )
}
